import API from './API.ts'

export default {
  //
  // GET
  //
  revokeMarketing (id) {
    return API.httpClient.post(`customers/${id}/revoke-marketing`)
  },
  getCustomer (id) {
    return API.httpClient.get(`customers/${id}`)
  },
  getCustomerBookings (id) {
    return API.httpClient.get(`customers/${id}/bookings`)
  },
  getCustomerInvoices (id) {
    return API.httpClient.get(`customers/${id}/invoices`)
  },
  getCustomerReceipts (id) {
    return API.httpClient.get(`customers/${id}/receipts`)
  },
  getCustomerEditingRecords (customerId) {
    return API.httpClient.get('customers/editing-records', {
      params: {
        customer_id: customerId
      }
    })
  },

  //
  // POST
  //
  saveCustomer (customer) {
    const payload = {
      id: customer.id,
      given_name: customer.given_name,
      surname: customer.surname,
      dialling_code_country_id: customer.diallingCodeCountry ? customer.diallingCodeCountry.id : null,
      phone_number: customer.phone_number,
      email: customer.email,
      street_name: customer.street_name,
      street_number: customer.street_number,
      zip: customer.zip,
      city: customer.city,
      is_org: customer.is_org,
      org_name: customer.org_name,
      org_number: customer.org_number,
      org_reference: customer.org_reference,
      country_id: customer.country.id
    }

    // Skicka med CKE-kortnummer om det finns — backend skapar SCRCustomer-koppling automatiskt
    if (customer.cke_card_number) {
      payload.cke_card_number = customer.cke_card_number
    }

    return API.httpClient.post('customers', payload)
  }
}
